import React from 'react';
import { Box, TextField, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import LancamentosTable from '../LancamentosTable';
import { Lancamento } from '../../services/types';

interface ObraLancamentosTabProps {
    obraId: number;
    filters: {
        search: string;
        startDate: string;
        endDate: string;
    };
    onFilterChange: (newFilters: any) => void;
    onEdit: (lancamento: Lancamento) => void;
    onDelete: (lancamento: Lancamento) => void;
    refreshTrigger: number;
}

export const ObraLancamentosTab: React.FC<ObraLancamentosTabProps> = ({
    obraId,
    filters,
    onFilterChange,
    onEdit,
    onDelete,
    refreshTrigger
}) => {
    return (
        <Box sx={{ p: 2 }}>
            <Box sx={{ display: 'flex', gap: 2, mb: 2, flexWrap: 'wrap' }}>
                <TextField
                    label="Buscar"
                    variant="outlined"
                    size="small"
                    value={filters.search}
                    onChange={(e) => onFilterChange({ ...filters, search: e.target.value })}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon />
                            </InputAdornment>
                        ),
                    }}
                    sx={{ flexGrow: 1 }}
                />
                <TextField
                    label="Data Início"
                    type="date"
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    inputProps={{ max: "9999-12-31" }}
                    value={filters.startDate}
                    onChange={(e) => onFilterChange({ ...filters, startDate: e.target.value })}
                />
                <TextField
                    label="Data Fim"
                    type="date"
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    inputProps={{ max: "9999-12-31" }}
                    value={filters.endDate}
                    onChange={(e) => onFilterChange({ ...filters, endDate: e.target.value })}
                />
            </Box>
            <LancamentosTable
                filters={{
                    obraId: obraId,
                    search: filters.search,
                    startDate: filters.startDate,
                    endDate: filters.endDate
                }}
                onEdit={onEdit}
                onDelete={onDelete}
                refreshTrigger={refreshTrigger}
            />
        </Box>
    );
};
